/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAccountsPayable = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m18 3.586 3.707 3.707-1.414 1.414L19 7.414V11h-2V7.414l-1.293 1.293-1.414-1.414zM2 5h11v2H4v10h16v-5h2v7H2zm8 6H6V9h4zm6 4H6v-2h10z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAccountsPayable as AccountsPayable };
